var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.376 16.484l-4.268-4.268a.417.417 0 00-.299-.123h-.463A7.311 7.311 0 007.812 0 7.311 7.311 0 00.5 7.312a7.311 7.311 0 0012.093 5.533v.464c0 .113.046.219.123.3l4.268 4.267a.422.422 0 00.598 0l.794-.794a.422.422 0 000-.598zM7.812 12.937a5.623 5.623 0 01-5.625-5.625 5.623 5.623 0 015.625-5.625 5.623 5.623 0 015.625 5.625 5.623 5.623 0 01-5.625 5.625z",
    fill: "#777"
  })));
}

export default SvgSearchIcon;